// Employees database (Management) data hooks.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Employee, EmployeeFieldsInput, EmployeeUpdateInput } from '@technohull/shared';
import { api } from '../lib/api.js';

export function useEmployees() {
  return useQuery({
    queryKey: ['employees'],
    queryFn: () => api.get<{ employees: Employee[] }>('/api/employees'),
  });
}

export function useCreateEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: EmployeeFieldsInput) => api.post<{ id: number }>('/api/employees', v),
    // employees feed the overtime roster, so refresh both.
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['employees'] }); void qc.invalidateQueries({ queryKey: ['overtime'] }); },
  });
}

export function useUpdateEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: EmployeeUpdateInput) => api.post('/api/employees/update', v),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['employees'] }); void qc.invalidateQueries({ queryKey: ['overtime'] }); },
  });
}

export function useDeleteEmployee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post('/api/employees/delete', { id }),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['employees'] }); void qc.invalidateQueries({ queryKey: ['overtime'] }); },
  });
}
